// extracted by mini-css-extract-plugin
module.exports = {"title":"_02712f2b3b--title--xYZau","row":"_02712f2b3b--row--R3GuT","key":"_02712f2b3b--key--_V9fb","value":"_02712f2b3b--value--J6J_z","warning":"_02712f2b3b--warning--YP8dJ"};